export enum AccountStatus {
	Pending = 'Pending',
	Accepted = 'Accepted',
	Rejected = 'Rejected',
}
